<page-toolbar title="Create Readme"></page-toolbar>

<page-content>
  <div class="form-container">
    <ng-template formHost></ng-template>
  </div>

  <div *ngIf="!!readme">
    <mat-tab-group (selectedTabChange)="tabChange($event)">
      <mat-tab label='de'></mat-tab>
      <mat-tab *ngFor="let translation of readme.translations; let i = index"
               [label]="translation.lang ? translation.lang : 'new'"></mat-tab>
    </mat-tab-group>

    <div *ngIf="selectedTabIndex === 0" class="editor">
      <angular-markdown-editor [(ngModel)]="readme.readme" [options]="editorOptions"
                               name="markdownText" [rows]="20" textareaId="editor">
      </angular-markdown-editor>
    </div>

    <div *ngFor="let translation of readme.translations; let i = index" class="editor">
      <ng-container *ngIf="selectedTabIndex > 0 && (selectedTabIndex - 1)  === i">
        <mat-form-field>
          <input [(ngModel)]="readme.translations[i].lang" matInput placeholder="lang">
        </mat-form-field>
        <mat-form-field>
          <input [(ngModel)]="readme.translations[i].title" matInput placeholder="title">
        </mat-form-field>
        <angular-markdown-editor [(ngModel)]="readme.translations[i].readme" [options]="editorOptions"
                                 name="markdownText" [rows]="20" textareaId="editor{{i}}">
        </angular-markdown-editor>
        <div class="button-right-container">
          <button (click)="removeTranslation(i)" class="ibexfusion-raised-button" mat-button>remove translation</button>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="button-right-container">
    <button (click)="addTranslation()" class="ibexfusion-raised-button" mat-button>add translation</button>
    <button (click)="chooseFromFileAssets()" class="ibexfusion-raised-button" mat-button>select file path</button>
    <button (click)="chooseFromImageAssets()" class="ibexfusion-raised-button" mat-button>select image path</button>
    <button (click)="save()" class="ibexfusion-raised-button" mat-button>save</button>
  </div>

</page-content>
